import React from 'react';

type TemplateErrorModalProps = {
  isAmp: boolean,
  hasMicrosoft: boolean,
  htmlErrors: number,
  spellingErrors: number,
  ampHtmlErrors: number,
  ampSpellingErrors: number,
  microsoftHtmlErrors: number,
  microsoftSpellingErrors: number,
};

export default function TemplateErrorModal(props: TemplateErrorModalProps) {
  const renderError = ({ htmlErrors, spellingErrors }) => {
    return (
      <ul>
        {htmlErrors > 0 && (
          <li style={{ padding: 0 }}>HTML Errors: {htmlErrors}</li>
        )}
        {spellingErrors > 0 && (
          <li style={{ padding: 0 }}>Spelling Errors: {spellingErrors}</li>
        )}
      </ul>
    );
  };
  return (
    <div className="space-y-4" style={{ marginTop: 16 }}>
      <div>
        <p style={{ marginBottom: 4, fontWeight: 'bold' }}>
          HTML Template Errors
        </p>
        {renderError({
          htmlErrors: props.htmlErrors,
          spellingErrors: props.spellingErrors,
        })}
      </div>
      {props.isAmp && (
        <div>
          <p style={{ marginBottom: 4, fontWeight: 'bold' }}>
            AMP Template Errors
          </p>
          {renderError({
            htmlErrors: props.ampHtmlErrors,
            spellingErrors: props.ampSpellingErrors,
          })}
        </div>
      )}

      {props.hasMicrosoft && (
        <div>
          <p style={{ marginBottom: 4, fontWeight: 'bold' }}>
            Microsoft HTML Template Errors
          </p>
          {renderError({
            htmlErrors: props.microsoftHtmlErrors,
            spellingErrors: props.microsoftSpellingErrors,
          })}
        </div>
      )}
    </div>
  );
}
